// angular import
import { Component } from '@angular/core';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class NavBarComponent {}
